import type { CreateTypeOfCallSopInputVesselStatusMappingDto, TypeOfCallSopInputVesselStatusMappingDto, UpdateTypeOfCallSopInputVesselStatusMappingDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DataRequestDto, EntitySchemaDto, IdNameDto, PageRequestDto } from '../models';
import type { SopInputDto } from '../sop-inputs/models';

@Injectable({
  providedIn: 'root',
})
export class TypeOfCallSopInputVesselStatusMappingService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  create = (input: CreateTypeOfCallSopInputVesselStatusMappingDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputVesselStatusMappingDto>({
      method: 'POST',
      headers: { Accept: 'application/json' },
      url: '/api/app/type-of-call-sop-input-vessel-status-mapping',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/type-of-call-sop-input-vessel-status-mapping/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputVesselStatusMappingDto>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/type-of-call-sop-input-vessel-status-mapping/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getByTypeOfCallId = (typeOfCallId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputVesselStatusMappingDto[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/type-of-call-sop-input-vessel-status-mapping/by-type-of-call-id/${typeOfCallId}`,
    },
    { apiName: this.apiName,...config });
  

  getCount = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/type-of-call-sop-input-vessel-status-mapping/count',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getDropDownOptions = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdNameDto>>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/type-of-call-sop-input-vessel-status-mapping/drop-down-options',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getExpandById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputVesselStatusMappingDto[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/type-of-call-sop-input-vessel-status-mapping/${id}/expand`,
    },
    { apiName: this.apiName,...config });
  

  getExtraPropertiesById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Record<string, object>>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/type-of-call-sop-input-vessel-status-mapping/${id}/extra-properties`,
    },
    { apiName: this.apiName,...config });
  

  getIds = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/type-of-call-sop-input-vessel-status-mapping/ids',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getList = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<TypeOfCallSopInputVesselStatusMappingDto>>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/type-of-call-sop-input-vessel-status-mapping',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getOneExtraPropertiesByIdAndKey = (id: string, key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, object>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-input-vessel-status-mapping/${id}/one-extra-properties`,
      params: { key },
    },
    { apiName: this.apiName,...config });
  

  getSchema = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EntitySchemaDto>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/type-of-call-sop-input-vessel-status-mapping/schema',
    },
    { apiName: this.apiName,...config });
  

  getSopInputs = (typeOfCallId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SopInputDto[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/type-of-call-sop-input-vessel-status-mapping/sop-inputs/${typeOfCallId}`,
    },
    { apiName: this.apiName,...config });
  

  getWithDetails = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputVesselStatusMappingDto>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/type-of-call-sop-input-vessel-status-mapping/${id}/with-details`,
    },
    { apiName: this.apiName,...config });
  

  setExtraPropertiesByIdAndKeyAndValue = (id: string, key: string, value: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/type-of-call-sop-input-vessel-status-mapping/${id}/set-extra-properties`,
      params: { key, value },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: UpdateTypeOfCallSopInputVesselStatusMappingDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputVesselStatusMappingDto>({
      method: 'PUT',
      headers: { Accept: 'application/json' },
      url: `/api/app/type-of-call-sop-input-vessel-status-mapping/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}